export const useEditorLayerHelpers = ({ setLayerId, tempLayer }) => {
  const getLayerDetails = (id, type, url) => {
    setLayerId({ eventDetails: id, type: type, url: url });
  };

  const layerSequence = (type) => {
    let result = tempLayer.current.filter((items) => {
      return items.componentType === type;
    });
    return result;
  };

  return {
    getLayerDetails,
    layerSequence,
  };
};
